<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HOprTK/tc-custom/9780300130263.jpg?1736424017347" alt="This image is the cover for the book What Stalin Knew"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What Stalin Knew
      </h1>
      <p class="bookDescription body article font2">
        <b>This “riveting account of one of history’s greatest blunders” chronicles Russia’s tragic mishandling of Nazi Germany’s invasion during WWII (William L. O’Neill, <i>The New Leader</i>).</b><br/>  <br/> On June 22, 1941, Nazi Germany’s Operation Barbarossa was launched against Russia. Within days, the invading army had taken hundreds of thousands of Soviet captives while the Luftwaffe bombed a number of Russian cities, including Minsk. Though accurate intelligence about the plan had been available to Stalin before the attack, he chose not to heed the warning.<br/>  <br/> In <i>What Stalin Knew</i>, historian and former chief of the CIA’s Soviet division David E. Murphy illuminates many of the enigmas surrounding the catastrophic invasion, offering keen insights into Stalin’s thinking and the reasons for his fatal error of judgment. A story of successful misinformation campaigns, and a leader more paranoid about threats from within his regime than from an aggressive neighbor, this authoritative history sheds essential new light on the most consequential event in the Eastern Front of World War II.<br/>  <br/><b>“If, after the war, the Soviet Union had somehow been capable of producing an official inquiry into the catastrophe of 6/22—comparable in its mandate to the 9/11 commission here—its report might have read a little like [this book]. . . . Murphy brings to his subject both knowledge of Russian history and an insider’s grasp of how intelligence is gathered, analyzed and used—or not.” —Niall Ferguson, <i>The New York Times Book Review</i></b><br/>  <br/><b>“A fascinating and meticulously researched account of mistaken assumptions and errors of judgment . . . Never before has this fateful period been so fully documented.” —Henry A. Kissinger</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David E. Murphy
      </h2>
      
      <p class="authorDescription body article">David E. Murphy, now retired, was chief of CIA&rsquo;s Berlin base from the early 1950s to 1961 and then became chief of Soviet operations at CIA headquarters in the United States. He is coauthor of <I>Battleground Berlin: CIA vs. KGB in the Cold War</I>, also published by Yale University Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?018dc9a9